//COMPANY IDS
export const ADVENTOURAGE = 'f5Ui6uQNI4RnZwM6gaMx';
export const DEVELOPER = 'I3ANuzttq4Qrvld5xuYb';
export const RAPIDCYCLING = 'wYxvJNGijJ5bJgNsckzg';
export const UTPOWERTOYS = 'weSZECmc0eCyztG8DKbh';
export const OUTTA_HERE_E_BIKES = '9QojDFeCywSHHy4A3HNV';
export const OUTTA_HERE_E_BIKES_BRYCE = '050qsRhEKaHRBK3E7Ajc';

//USER IDS
export const OUTTA_HERE_SHARED_ACCOUNT_USER_ID = 'KYSCIzDMfvWyOMMqdGerAi3Z6ym1'; // Outta Here E Bikes shared account. (Lets them switch between the two companies)
export const FLEETMAID_SECTION_USER_ID = 'GHtIJGDdnFNMwqfxdsEIIKnwc1M2';
// single source of the reporting-access rule; JOSH_USER_ID is a fallback for Josh accounts without role flags
export const JOSH_USER_ID = 'GHtIJGDdnFNMwqfxdsEIIKnwc1M2';

//CATEGORIES
export const BOATCATEGORY = 'nBBHMCXkgNaPFnnulMbF';
